export default __webpack_public_path__ + "static/realWorldImg3-afb0442fa67c6c5e3872a15a14c41402.png";